import { render, staticRenderFns } from "./TheNavbarMenuDocumentTab.vue?vue&type=template&id=0b0e5f6e&"
import script from "./TheNavbarMenuDocumentTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheNavbarMenuDocumentTab.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports